import { Sprite3D } from "../../../../d3/core/Sprite3D";
import { Utils3D } from "../../../../d3/utils/Utils3D";
import { Matrix4x4 } from "../../../../maths/Matrix4x4";
import { Stat } from "../../../../utils/Stat";
import { WebBaseRenderNode } from "./WebBaseRenderNode";
var CLSSK = null;
export function WebSkinRenderNode() {
    if (!CLSSK)
        CLSSK = class extends WebBaseRenderNode.BaseRenderNodeClass {
            constructor() {
                super();
                this._bones = [];
                this.set_renderUpdatePreCall(this, this._renderUpdate);
            }
            setRootBoneTransfom(value) {
                this._cacheRootBone = value.transform;
            }
            setOwnerTransform(value) {
                this._owner = value.transform;
            }
            setCacheMesh(cacheMesh) {
                this._cacheMesh = cacheMesh;
                this._skinnedDataLoopMarks = new Uint32Array(cacheMesh._inverseBindPoses.length);
            }
            setBones(value) {
                this._bones = value;
            }
            setSkinnedData(value) {
                this._skinnedData = value;
            }
            computeSkinnedData() {
                var bindPoses = this._cacheMesh._inverseBindPoses;
                var pathMarks = this._cacheMesh._skinnedMatrixCaches;
                for (var i = 0, n = this._cacheMesh.subMeshCount; i < n; i++) {
                    var subMeshBoneIndices = ((this._cacheMesh.getSubMesh(i)))._boneIndicesList;
                    var subData = this._skinnedData[i];
                    for (var j = 0, m = subMeshBoneIndices.length; j < m; j++) {
                        var boneIndices = subMeshBoneIndices[j];
                        this._computeSubSkinnedData(bindPoses, boneIndices, subData[j], pathMarks);
                    }
                }
            }
            _computeSubSkinnedData(bindPoses, boneIndices, data, matrixCaches) {
                for (let k = 0, q = boneIndices.length; k < q; k++) {
                    let index = boneIndices[k];
                    if (this._skinnedDataLoopMarks[index] === Stat.loopCount) {
                        let c = matrixCaches[index];
                        let preData = this._skinnedData[c.subMeshIndex][c.batchIndex];
                        let srcIndex = c.batchBoneIndex * 16;
                        let dstIndex = k * 16;
                        for (let d = 0; d < 16; d++)
                            data[dstIndex + d] = preData[srcIndex + d];
                    }
                    else {
                        let bone = this._bones[index];
                        if (bone)
                            Utils3D._mulMatrixArray(bone.transform.worldMatrix.elements, bindPoses[index].elements, 0, data, k * 16);
                        this._skinnedDataLoopMarks[index] = Stat.loopCount;
                    }
                }
            }
            _renderUpdate(context3D) {
                let mat = this._owner.worldMatrix;
                let worldParams = this._worldParams;
                worldParams.x = this._owner.getFrontFaceValue();
                if (this._cacheRootBone) {
                    mat = Matrix4x4.DEFAULT;
                    worldParams.x = 1;
                }
                this._applyLightProb();
                this._applyReflection();
                this.shaderData.setMatrix4x4(Sprite3D.WORLDMATRIX, mat);
                this.shaderData.setVector(Sprite3D.WORLDINVERTFRONT, worldParams);
            }
        };
    return CLSSK;
}
